// import authorization from 'live/services/authorization'

// import { getAlarmSettings } from './services'
import { ChartState, ChartMessage, ChartEvent } from './types/batchEvent'

// import {} from 'react'
const syncbool = false
let alarmCount = 0
let alarmEventData: ChartEvent = { timestamp: 0 } as ChartEvent
const barrierMap: Map<number, ChartEvent> = new Map()
const escalationMap: Map<number, ChartEvent> = new Map()
const consequenceMap: Map<number, ChartEvent> = new Map()
const threatMap: Map<number, ChartEvent> = new Map()
const topEvent: Map<number, ChartEvent> = new Map()
const alarms: Map<number, ChartEvent> = new Map()

const IsValidTodispatchAlarmSound = (): boolean => {
    if (alarmCount) {
        alarmCount = 0

        return true
    } else {
        return false
    }
}

// const currentUser: string = authorization.user.username

const typeMapping = {
    __dra_barrier_latest: 'barriers',
    __dra_consequence_latest: 'consequences',
    __dra_threat_latest: 'threats',
    __dra_topevent_latest: 'topEvents',
    __dra_escalationfactor_latest: 'escalationFactors',
    __dra_alarms_latest: 'alarms'
}

// const verifyBowtieSelected = (idBowtie: number, selectedsBowties: number[]): boolean => {
//     if (selectedsBowties?.includes(idBowtie)) return true
// }

// const dispatchAlarmSound = async (alarm: ChartEvent): Promise<void> => {
//     const userInfo = await getAlarmSettings(currentUser)

//     const verifier = userInfo?.selectedBowties.map(selectedBowtie => {
//         return verifyBowtieSelected(selectedBowtie.bowtieId, alarm?.bowties_id)
//     })

//     if (IsValidTodispatchAlarmSound() && verifier?.includes(true) && userInfo?.soundNotification) {
//         new Audio('/content/plugin-codaf-risk-ext-bowtie/WarningAlarm.mp3').play()
//     }
// }

function getInitialState(): ChartState {
    return {
        barriers: barrierMap,
        consequences: consequenceMap,
        threats: threatMap,
        topEvents: topEvent,
        escalations: escalationMap,
        alarms: alarms,
        // IsValidTodispatchAlarmSound: IsValidTodispatchAlarmSound,
        event: alarmEventData,
        extraInfo: ''
    }
}

// function handleEvents(message:ChartMessage):ChartState{

// }

export const reducer: WidgetReducerType<ChartState, ChartMessage> = (state = getInitialState(), message) => {
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    switch (message.type) {
        case 'start':
            return { ...getInitialState(), extraInfo: message?.events?.info?.extraInfo }

        case 'event':
            message.events?.forEach(el => {
                const type = typeMapping[el.__type] as string
                if (type && type in state && el.__type !== '__dra_alarms_latest') {
                    if (state[type].has(el.id)) {
                        const oldEvent = state[type].get(el.id)
                        const oldEventTS = oldEvent.ts ? oldEvent.ts : oldEvent.timestamp
                        if (oldEventTS < el.ts) {
                            state[type].set(el.id, el)
                        } else if (oldEventTS === el.ts && oldEvent.version < el.version) {
                            state[type].set(el.id, el)
                        }
                    } else {
                        state[type].set(el.id, el)
                    }
                } else {
                    alarms.set(el.id, el)
                    // dispatchAlarmSound(el)
                    alarmCount += 1
                    alarmEventData = el
                }
            })

            return { ...state, event: alarmEventData }

        default:
            return state
    }
}
